import axios from "axios";
import { showSuccessNotification, showErrorNotification } from "actions/action-complete-notificator";

export const ACTION_LOG_OUT_USER_PENDING = 'ACTION_GET_CURRENT_USER_PENDING';
export const ACTION_LOG_OUT_USER_SUCCESS = 'ACTION_GET_CURRENT_USER_SUCCESS';
export const ACTION_LOG_OUT_USER_ERROR = 'ACTION_GET_CURRENT_USER_ERROR';

function logOutUserPending() {
    return {
        type: ACTION_LOG_OUT_USER_PENDING
    }
}

function logOutUserSuccess(translations) {
    showSuccessNotification(translations.signedOut);
    return {
        type: ACTION_LOG_OUT_USER_SUCCESS,
        loggedIn: false
    }
}

function logOutUserError(error) {
    showErrorNotification(error.response);
    return {
        type: ACTION_LOG_OUT_USER_ERROR,
        error: error
    }
}

function logOutUserAction(translations) {
    axios.defaults.baseURL = window.location.origin;
    var url = '/api/User/LogOut';
    return dispatch => {
        dispatch(logOutUserPending());
        axios.post(url, null, { withCredentials: true })
            .then(() => {
                dispatch(logOutUserSuccess(translations));
            })
            .catch(error => {
                dispatch(logOutUserError(error));
            })
    }
}

export default logOutUserAction;
